<template>
  <el-pagination @current-change="onPageChange"
                 @size-change="onPageSizeChange"
                 :page-sizes="[10, 20, 50, 100]"
                 :total="iTotal"
                 :current-page="iCurrentPage"
                 :page-size="iPageSize"
                 background
                 layout="total, sizes, prev, pager, next, jumper"></el-pagination>
</template>
<script>
export default {
  name: "xPagination", // 组件名
  inject: ["pagination"], // 接收后面mixins中provider的提供的参数
  props: {
    total: {
      // 总页数
      type: Number,
      default: 20
    },
    page: {
      // 当前页
      type: Number,
      default: 1
    },
    per_page: {
      // 每页显示条数
      type: Number,
      default: 10 // 默认10条
    }
  },
  watch: {
    pagination: {
      // 监听器
      deep: true,
      handler(v) {
        if (!v) {
          return;
        }
        const { per_page, total, page } = v;
        this.iPageSize = per_page;
        this.iTotal = total;
        this.iCurrentPage = page;
      }
    }
  },
  data() {
    return {
      iPageSize: this.per_page,
      iCurrentPage: this.page,
      iTotal: this.total
    };
  },
  methods: {
    _emitPaginationChangeInfo() {
      // 触发父组件中特定的pageChanged函数
      const pageInfo = {
        per_page: this.iPageSize,
        page: this.iCurrentPage
      };
      this.$emit("pageChanged", pageInfo);
    },
    onPageSizeChange(per_page) {
      // 每页条数改变函数
      this.iCurrentPage = 1;
      this.iPageSize = per_page;
      this._emitPaginationChangeInfo();
    },
    onPageChange(page) {
      // 页码改变函数
      this.iCurrentPage = page;
      this._emitPaginationChangeInfo();
    }
  }
};
</script>

<style scoped lang="less">
.el-pagination {
  float: right;
  margin-top: 20px;
}
</style>